import * as React from 'react';
import { Label as FluentLabel, type LabelProps as FluentLabelProps } from '@fluentui/react-components';

export type LabelProps = FluentLabelProps;

export const Label: React.FC<LabelProps> = ({ children, className, ...rest }) => {
  return (
    <FluentLabel className={className} {...rest}>
      {children}
    </FluentLabel>
  );
};


